import {
  GET_WO_FOR_MARKETING_EXPENSE,
  GET_WO_ITEM_FOR_MARKETING_EXPENSE,
  GET_ITEM_FOR_MARKETING_EXPENSE,
  GET_MARKETING_EXPENSE,
  GET_MARKETING_EXPENSE_DETAIL,
  GET_MARKETING_EXPENSE_EXPORT,
  //Marketing Campaign
  GET_MARKETING_CAMPAIGN,
  GET_MARKETING_CAMPAIGN_DETAIL,
  GET_MARKETING_CAMPAIGN_FILTER_PROJECT
} from "./types";

const initialState = {
  getWOForMarketingExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getWOItemForMarketingExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getItemForMarketingExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingExpenseDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingExpenseExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Marketing Campaign
  getMarketingCampaign: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingCampaignDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingCampaignFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};

const Marketing_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_WO_FOR_MARKETING_EXPENSE:
      return Object.assign({}, state, {
        getWOForMarketingExpense: payload
      });
    case GET_WO_ITEM_FOR_MARKETING_EXPENSE:
      return Object.assign({}, state, {
        getWOItemForMarketingExpense: payload
      });
    case GET_ITEM_FOR_MARKETING_EXPENSE:
      return Object.assign({}, state, {
        getItemForMarketingExpense: payload
      });
    case GET_MARKETING_EXPENSE:
      return Object.assign({}, state, {
        getMarketingExpense: payload
      });
    case GET_MARKETING_EXPENSE_DETAIL:
      return Object.assign({}, state, {
        getMarketingExpenseDetail: payload
      });
    case GET_MARKETING_EXPENSE_EXPORT:
      return Object.assign({}, state, {
        getMarketingExpenseExport: payload
      });
    //Marketing Campaign
    case GET_MARKETING_CAMPAIGN:
      return Object.assign({}, state, {
        getMarketingCampaign: payload
      });

    case GET_MARKETING_CAMPAIGN_DETAIL:
      return Object.assign({}, state, {
        getMarketingCampaignDetail: payload
      });

    case GET_MARKETING_CAMPAIGN_FILTER_PROJECT:
      return Object.assign({}, state, {
        getMarketingCampaignFilterProject: payload
      });
    default:
      return state;
  }
};

export default Marketing_reducer;
